import { Placement as PlacementType } from '@popperjs/core';
import React, { ReactNode } from 'react';
import { OverlayTrigger, OverlayTriggerProps, Tooltip, TooltipProps } from 'react-bootstrap';

type Props = Omit<OverlayTriggerProps, 'overlay'> & {
	children: any;
	title: ReactNode;
	className?: string;
	tooltipProps?: TooltipProps;
};

export type Placement = PlacementType;

const OctTooltip = ({ children, title, className, tooltipProps, ...props }: Props) => {
	return (
		<OverlayTrigger
			placement="auto"
			overlay={<Tooltip {...tooltipProps}>{title}</Tooltip>}
			{...props}
		>
			{children}
		</OverlayTrigger>
	);
};

export default OctTooltip;
